type CodeTemplate = string;

export const DEFAULT_CODE_TEMPLATE: CodeTemplate = 'default';

export default CodeTemplate;
